package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.models.Event
import com.rainbowclubs.rainbow.data.requests.UpdateEventRequest
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class UpdateEventUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(
        eventId: String,
        request: UpdateEventRequest,
    ): Result<Event> {
        return eventsRepository.updateEvent(
            eventId = eventId,
            request = request,
        )
    }
}
